import {
    PrimaryButton,
    PrimaryText,
    SecondaryButton,
    SecondaryText,
} from "../Company/companyAuthSetting/SsoStyledComponents";
import { useContext } from "react";
import { ApplicationContext } from "../../components/ApplicationProvider";
import Parser from "html-react-parser";
import {
    AnalyzeSaasModal,
    AnalyzeSaasModalButtonsWrapper,
    AnalyzeSaasModalContainer,
    AnalyzeSaasModalMessage,
} from "./AnalyzeStyle";

export interface AnalyzeSaasInfoModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const AnalyzeSaasModalPopup = ({ open, onClose, onConfirm }: AnalyzeSaasInfoModalProps) => {
    const { t } = useContext(ApplicationContext);

    return (
        <AnalyzeSaasModal open={open} onClose={onClose} size="small">
            <AnalyzeSaasModalContainer>
                <AnalyzeSaasModalMessage data-testid="saas-modal-message">
                    <p>{Parser(t("analyze_selection.saas_modal_message"))}</p>
                </AnalyzeSaasModalMessage>

                <AnalyzeSaasModalButtonsWrapper>
                    <SecondaryButton onClick={onClose}>
                        <SecondaryText>
                            <p>{t("configure_sso_setting.sso_modal.sso_modal_cancel")}</p>
                        </SecondaryText>
                    </SecondaryButton>
                    <PrimaryButton
                        onClick={() => {
                            onClose();
                            onConfirm();
                        }}
                    >
                        <PrimaryText>
                            <p>{t("configure_sso_setting.sso_modal.sso_modal_continue")}</p>
                        </PrimaryText>
                    </PrimaryButton>
                </AnalyzeSaasModalButtonsWrapper>
            </AnalyzeSaasModalContainer>
        </AnalyzeSaasModal>
    );
};

export default AnalyzeSaasModalPopup;
